/**
 * ModalPortal — escape ancestor stacking contexts.
 *
 * Why this exists
 * ───────────────
 * Pages like `DropsPage` wrap their content in `<div className="relative z-10 ...">`
 * to layer above a backdrop. CSS rule: a positioned element with z-index creates
 * a NEW stacking context. So a modal mounted INSIDE that wrapper has its z-index
 * confined to the wrapper's local context — meaning a `fixed inset-0 z-50` modal
 * effectively paints AT z-10 against the rest of the document. The navbar
 * (also fixed, z-50, but a top-level sibling of <App>) wins the painting order
 * and the modal's title gets clipped behind the navbar.
 *
 * Fix: render the modal as a child of <body> via `createPortal`. The modal
 * then escapes every ancestor stacking context and its z-index is global.
 *
 * Usage
 * ─────
 *   <ModalPortal>
 *     <div className="fixed inset-0 z-[100] bg-black/80">…</div>
 *   </ModalPortal>
 *
 * No-op on SSR — checks `document` before portaling.
 */
import { createPortal } from "react-dom";

export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
